import React, { useState } from "react";

import {
  Select,
  MenuItem,
  TextareaAutosize,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  useMediaQuery,
  DialogContentText,
  Typography,
  Grid,
  Paper
} from "@material-ui/core";

import { AdministratorEvent, LifvsUser } from "../../../models/User";
import * as UserApi from "../../../api/users";
import { useTheme } from "@material-ui/core/styles";
import MaterialTable, { MTableToolbar } from "@material-table/core";
import moment from "moment";
import { isOk } from "../../../result";
import { Alert } from "@material-ui/lab";

export interface AddCommentModalProps {
  readonly user: LifvsUser;
  readonly visible: boolean;
  readonly onCloseDialog: (success: boolean) => void;
  readonly comments: [];
}

const AddCommentModal = ({
  user,
  visible,
  comments,
  onCloseDialog
}: AddCommentModalProps) => {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("xs"));

  const [comment, setComment] = useState<string>("");

  const [errors, setErrors] = useState({
    message: null as any,
    problem: null as any
  });

  const onAddComment = () => {
    if (comment) {
      return UserApi.addComment(user.id, comment).then(result => {
        if (!isOk(result)) {
          return setErrors({ ...errors, problem: result.details });
        }

        setComment("");
        onCloseDialog(true);
      });
    } else {
      setErrors({ ...errors, message: "Enter a comment" });
    }
  };

  return (
    <Dialog
      onClose={() => onCloseDialog(false)}
      open={visible}
      fullWidth={true}
      fullScreen={mobile}
      maxWidth={"sm"}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle>Comments</DialogTitle>
      <DialogContent>
        {comments.length > 0 ? (
          <MaterialTable
            isLoading={false}
            columns={[
              {
                title: "Date",
                field: "timeStamp",
                render: (row: any) => moment(row.timeStamp).format("YYYY-MM-DD")
              },
              {
                title: "Comment",
                field: "comment"
              },
              {
                title: "Administrator",
                field: "userName",
                hidden: mobile
              }
            ]}
            data={comments ? (comments as []) : []}
            components={{
              Container: props => <Paper {...props} elevation={0} />,
              Toolbar: props => (
                <div style={{ height: 0 }}>
                  <MTableToolbar {...props} />
                </div>
              )
            }}
            options={{
              emptyRowsWhenPaging: false
            }}
          />
        ) : (
          <></>
        )}

        <DialogContentText>
          {comments.length > 0 ? (
            <h4>{t("common.actions.addComment")}</h4>
          ) : (
            <></>
          )}
          Enter a comment for user{" "}
          <strong>
            {user.firstName} {user.lastName}
          </strong>
        </DialogContentText>
        <TextField
          label={"Comment"}
          multiline
          rows={5}
          style={{
            minWidth: 120,
            width: mobile ? "100%" : "80%",
            marginBottom: 15
          }}
          value={comment}
          error={errors?.message}
          onChange={({ target: { value } }) => setComment(value)}
        />
        {errors?.problem && (
          <Alert severity="error">
            {t("common.messages.errorAddingComment")}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button color={"primary"} onClick={() => onCloseDialog(false)}>
          Cancel
        </Button>
        <Button color={"primary"} onClick={onAddComment}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddCommentModal;
